import React from 'react';
import video from '../Medias/Medias/video.mp4';
import { Container, Row, Col } from 'react-bootstrap';
import logoPT from '../Medias/LogosPT/logo_h.png';
import { urlApi, storageUrl } from '../Constants/Global';
import MultiItemCarousel from './MultiItemCarousel';

const SectionVideoBg = ({ contents, videoContent }) => {
  return (
    <section className='video-bg-container'>
      <video className="video-bg" autoPlay muted loop playsInline>
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {videoContent}

      <Container className='pt-5 pb-5 mb-5 position-relative'>
        <Row>
          <Col xs={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }}>
            <Row>
              <Col>
                <MultiItemCarousel items={contents?.web_setup?.client_logo} sm={1} md={6} lg={6} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* <div className='position-absolute w-100 h-100 text-white'>
        <Container className='position-absolute top-50 start-50 translate-middle home-content'>
          <Row>
            <Col>
              <h1 className='font-header'>PT & Associates</h1>
              <h3>Creative Legal Strategies</h3>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6}>Our boutique law firm PT & Associates (PTA) is known for its multi-disciplinary perspectives for solving legal and regulatory challenges for our clients in the energy industry both in the private and government sectors. Our professional team brings expertise from diverse academic and industry backgrounds to formulate and implement legal strategies that address our clients’ business needs. Our services consist of inventive legal solutions tailored to deliver client-determined optimal results.
            </Col>
            <Col xs={12} md={6}>Beyond providing legal services, PTA maintains the not-for-profit Energy Law Center (ELC) with the generous support of corporate social responsibility (CSR) donors who share our vision of creating an open and neutral platform for energy law scholarship and discussions. The ELC serves as a forum for community outreach — supporting news and events, regulatory updates, energy education and trends, and publications — that provides general information to various stakeholders to understand the economic and social value of energy law.
            </Col>
          </Row>
        </Container>
      </div> */}
    </section>
  )
}

export default SectionVideoBg